import { ReactNode, useState } from 'react';
import TariffSelectorPanel from './TariffSelectorPanel';
import { TariffSelectorProps } from './TariffSelectorProps';
import { Tagged } from '../Tagged';
import { P2GBox } from '@parcel2go/core-ui';
import { P2GSidePanel } from '~/components/sidepanel';

interface props extends TariffSelectorProps {
  control: ReactNode;
}

const TariffSelector: React.FC<props> = (props) => {
  const [open, setOpen] = useState(false);

  const onSelect = (code: string) => {
    if (props.selectCode) {
      props.selectCode(code.replaceAll(' ', ''));
      setOpen(false);
    }
  };

  const openModal = () => {
    setOpen(true);
  };

  return (
    <>
      <P2GBox component="span" onClick={openModal}>
        {props.control}
      </P2GBox>
      <P2GSidePanel open={open} anchor="right" onClose={() => setOpen(false)} title={props.title} width="600px">
        {open && (
          <Tagged tag="panel-tariffcodes">
            <TariffSelectorPanel {...props} selectCode={onSelect} />
          </Tagged>
        )}
      </P2GSidePanel>
    </>
  );
};

export { TariffSelector };
